import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("wtr_login");

  return isAuthenticated ? children : <Navigate to="/sso" />;
};

export default PrivateRoute;